import { t } from "i18next";
import { useEffect, useState } from "react";
import { PlanTemplateService } from "../../services/PlanTemplateService";
import { sort } from "../../utils/utils";
import { ERROR, useNotification } from "../CustomHooks/NotificationProvider";
import { Selector } from "../Selectors/Selector";

const TemplateSelector = ({
  label,
  selectHandler,
  interaction,
  selectedItemId,
}) => {
  const showNotification = useNotification();
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    PlanTemplateService.getTemplates()
      .then((res) => {
        res = res.map((template) => ({ label: template.name, ...template }));
        res = sort(res, (template) => template.label);
        setTemplates(res);
      })
      .catch(() =>
        showNotification(
          t("notifications.general.fetchError", { obj: "Templates" }),
          ERROR
        )
      );
  }, [showNotification]);

  const selectWrapper = (templateId) => {
    const selectedTemplate = templates.find((t) => t.id === templateId);
    selectHandler(selectedTemplate);
  };

  return (
    <Selector
      id="template-selector"
      label={label}
      options={templates}
      selectHandler={selectWrapper}
      interaction={interaction}
      selectedItemId={selectedItemId}
    />
  );
};

export default TemplateSelector;
